import { Mail } from 'lucide-react';
import { Step } from 'shared/InstallationDialog';
import { spawn } from 'utils/translations';

const spawnBeforeYouBegin = spawn(
  'dialogs.bitbucket-installation.before-you-begin',
);

export const BeforeYouBegin = () => {
  return (
    <Step
      title={spawnBeforeYouBegin('title')}
      description={spawnBeforeYouBegin('description')}
    >
      <p className="text-sm text-text-general-neutral-mild">
        {spawnBeforeYouBegin('admin-warning')}
      </p>
      <div className="flex items-center gap-4">
        <Mail className="size-4 shrink-0 text-text-general-neutral-mid" />
        <p className="text-h5 text-text-general-neutral-mid">
          {spawnBeforeYouBegin('email-notice')}
        </p>
      </div>
    </Step>
  );
};
